export const fillSurveySelector = state => state.fillSurvey;
